import React from 'react';
import { Download } from 'lucide-react';
import { Button } from '../ui/Button';
import { DataSourceChip } from './DataSourceChip';
import { cn } from '../../lib/utils';

export function JourneyPageHeader({
  leading = null,
  dataSourceLabel,
  onExport,
  exportLabel = 'Export',
  className,
}) {
  if (!leading && !dataSourceLabel && !onExport) return null;

  return (
    <header
      className={cn(
        'flex flex-wrap items-center gap-3',
        leading ? 'justify-between' : 'justify-end',
        className
      )}
    >
      {leading ? <div className="min-w-0">{leading}</div> : null}
      <div className="flex flex-shrink-0 flex-wrap items-center gap-2 sm:ml-auto">
        <DataSourceChip label={dataSourceLabel} />
        {onExport ? (
          <Button
            type="button"
            variant="outline"
            size="sm"
            onClick={onExport}
            className="gap-2 rounded-lg"
          >
            <Download className="h-3.5 w-3.5" aria-hidden="true" />
            {exportLabel}
          </Button>
        ) : null}
      </div>
    </header>
  );
}
